import { render, staticRenderFns } from "./bkLvList.vue?vue&type=template&id=022f6b3a&scoped=true"
import script from "./bkLvList.vue?vue&type=script&lang=js"
export * from "./bkLvList.vue?vue&type=script&lang=js"
import style0 from "./bkLvList.vue?vue&type=style&index=0&id=022f6b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f6b3a",
  null
  
)

export default component.exports